import { TinySliderInfo, TinySliderInstance, tns } from 'tiny-slider/src/tiny-slider';

export default class Sliders {
    static init(): void {
        this.hpHeaderSlider();
        this.articleSlider();
    }

    static hpHeaderSlider(): void {
        const carousel = document.querySelector<HTMLElement>('.js-hp-slider');
        if (carousel) {
            const slider = tns({
                container: '.hp-slider__inner',
                items: 1,
                nav: true,
                navPosition: 'bottom',
                controls: false,
                gutter: 0,
                loop: true,
                //autoWidth: true,
                mouseDrag: true,
                preventScrollOnTouch: 'auto',
                swipeAngle: 30,
                autoplayTimeout: 5000,
                autoplayButtonOutput: false,
                autoplay: true,
                autoplayButton: false,
            });
        }
    }

    static articleSlider(): void {
        const carousel = document.querySelector<HTMLElement>('.js-article-slider');
        if (carousel) {
            const slider = tns({
                container: '.article-slider__inner',
                items: 1,
                nav: false,
                controls: true,
                controlsContainer: '.article-slider__controls',
                gutter: 24,
                loop: false,
                mouseDrag: true,
                preventScrollOnTouch: 'auto',
                swipeAngle: 30,
                responsive: {
                    1200: {
                        items: 1.38,
                        gutter: 80,
                    },
                }
            });
        }
    }


}
